import { Component, OnInit } from '@angular/core';
import { SiteService } from 'src/app/services/site.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class DesignComponent implements OnInit {
  constructor(
    private _siteService: SiteService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {}
}
